import {
  Component,
  ElementRef,
  inject,
  model,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import * as uuid from 'uuid';
import { LabelOptions } from '@core/classes/options/label-options';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SwitchOptions } from '@shared/components';
import {FormControl, ReactiveFormsModule} from '@angular/forms';

export class RadiosOptions {
  id?: string = uuid.v4();
  value?: number;
  formControl?: FormControl<any>;
  options?: { value: any; label: string }[];
  onInput?: (value: any) => any;
  disabled?: boolean | false;
  required?: boolean | true;

  constructor(args?: RadiosOptions) {
    this.id = args?.id || uuid.v4();
    this.value = args?.value;
    this.formControl = args?.formControl;
    this.options = args?.options;
    this.onInput = args?.onInput;
    this.disabled = args?.disabled !== undefined ? args?.disabled : false;
    this.required = args?.required !== undefined ? args?.required : false;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-radios',
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './radios.component.html',
  styleUrl: './radios.component.scss',
})
export class RadiosComponent implements OnInit {
  @ViewChildren('radio') public radioEls!: QueryList<any>;
  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('radios');

  options = model(new RadiosOptions());

  ngOnInit(): void {
    console.log(this.radioEls);
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('radios');
    });
  }

  onInput(value: any) {
    console.log(this.radioEls);
    this.options().value = value;
    if (this.options()?.onInput) {
      this.options().onInput?.(value);
    }
  }

  reset() {
    this.options().value = undefined;

    if(this.options().disabled) {
      this.disable();
    }
  }

  enable() {
    if(this.options().formControl) {
      this.options().formControl?.enable();
    }
  }

  disable() {
    if(this.options().formControl) {
      this.options().formControl?.disable();
    }
  }

  protected readonly ElementRef = ElementRef;
}
